var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterOffDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3148 3.25H3.00001C2.70718 3.25 2.44114 3.42042 2.31871 3.68643C2.19628 3.95243 2.23986 4.26537 2.43031 4.4878L9.45001 12.6861V19.2222C9.45001 19.5076 9.61201 19.7683 9.86793 19.8947L13.4679 21.6725C13.7004 21.7873 13.9757 21.7739 14.1959 21.637C14.4161 21.5002 14.55 21.2593 14.55 21V12.6861L17.1519 9.64735C16.6735 9.45696 16.2315 9.19485 15.8391 8.8743L13.2303 11.9211C13.114 12.057 13.05 12.23 13.05 12.4089V19.7932L10.95 18.7561V12.4089C10.95 12.23 10.8861 12.057 10.7697 11.9211L4.62955 4.75H14.0061C14.032 4.22459 14.139 3.7205 14.3148 3.25Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5C22.5 6.933 20.933 8.5 19 8.5C17.067 8.5 15.5 6.933 15.5 5C15.5 3.067 17.067 1.5 19 1.5C20.933 1.5 22.5 3.067 22.5 5Z",
    fill: "#3468ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOffDot);
export default __webpack_public_path__ + "static/media/Filter-off-dot.69070b29a2b9c079eedae8787abc8037.svg";
export { ForwardRef as ReactComponent };